import {
    ChangeDetectionStrategy,
    Component,
    output,
    viewChild,
} from '@angular/core';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { ClientEligibilityStatus } from 'lemunzo-api';

@Component({
    selector: 'apcam-eligibility-menu',
    imports: [MatMenuModule, TranslatePipe],
    templateUrl: './eligibility-menu.component.html',
    styleUrl: './eligibility-menu.component.scss',
    exportAs: 'eligibilityMenu',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EligibilityMenuComponent {
    readonly eligibilityChange = output<ClientEligibilityStatus>();

    readonly menu = viewChild.required(MatMenu);

    protected readonly ClientEligibilityStatus = ClientEligibilityStatus;
}
